<template>
	<div class="flex flex-col bg-slate-100">
		<div class="sticky flex items-center px-5 py-4 bg-white shadow-sm top-safe">
			<Icon
				name="mdi:arrow-right"
				class="w-9 h-9 p-1.5 rounded-full -ms-1.5 text-primary bg-primary bg-opacity-0 hover:bg-opacity-10 duration-300 cursor-pointer transform ltr:-scale-x-100"
				@click="$backWithFallback($routeUrl.HomeUrl())"
			/>
			<div class="flex-grow" />
			<NuxtLink :to="$routeUrl.HomeUrl()">
				<img src="/img/main_logo.png" alt="" class="w-auto h-8" />
			</NuxtLink>
		</div>
		<div class="flex flex-col items-center flex-grow px-6 pt-16 pb-16">
			<main class="flex flex-col w-full max-w-screen-lg prose-sm prose md:prose-lg lg:prose-xl prose-slate">
				<h1>Privacy Policy</h1>

				<p>
					This Privacy Policy describes how your personal information is collected, used, and shared when you
					use the Jiran app (referred to as "we," "us," or "our").
				</p>

				<h2>Information We Collect</h2>

				<p>
					We may collect information that you provide directly, such as when you create an account, post
					content, or communicate with us. This information may include your name, email address, and any
					other information you choose to provide.
				</p>

				<p>
					We also automatically collect certain information when you use the Jiran app, including your IP
					address, device information, usage data, and analytics information.
				</p>

				<h2>How We Use Your Information</h2>

				<p>We use the information we collect for various purposes, including:</p>

				<ul>
					<li>Providing and maintaining the app</li>
					<li>Improving, personalizing, and expanding our app</li>
					<li>Communicating with you</li>
					<li>Marketing and promoting our app</li>
				</ul>

				<h2>Sharing Your Information</h2>

				<p>We do not track your activity across apps and websites for advertising purposes or share data with data brokers.</p>

				<h2>Security</h2>

				<p>
					We take reasonable measures to protect your personal information, but no method of transmission over
					the internet or electronic storage is 100% secure. We cannot guarantee absolute security.
				</p>

				<h2>Your Choices</h2>

				<p>
					You can always access and modify your personal information through your account settings. You can
					also opt-out of marketing communications.
				</p>

				<h2>Contact Us</h2>

				<p>
					If you have any questions or concerns about this Privacy Policy, please contact us at
					dev.jiran@gmail.com
				</p>
			</main>
		</div>
	</div>
</template>
